module.exports = __webpack_public_path__ + "img/project.28eb920e.jpg";